var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    enableBackground: "new 0 0 72 72",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36,2.334c9.047,0,17.536,3.59,23.807,9.861c1.131,1.131,2.18,2.339,3.137,3.614l-0.009-6.742 c0-1.727,1.3-3.149,2.973-3.344L66.3,5.701c1.728,0,3.151,1.3,3.346,2.974l0.021,0.393v16.833c0,1.727-1.299,3.15-2.974,3.345 L66.3,29.268H49.467c-1.858,0-3.366-1.507-3.366-3.367c0-1.726,1.3-3.149,2.974-3.344l0.393-0.023l9.865,0.001 c-1.177-2.034-2.618-3.91-4.287-5.579C50.024,11.936,43.243,9.067,36,9.067c-14.875,0-26.934,12.06-26.934,26.934 c0,14.875,12.059,26.934,26.934,26.934c7.243,0,14.024-2.867,19.045-7.889c2.501-2.502,4.492-5.47,5.848-8.736 c0.673-1.624,1.186-3.313,1.529-5.049c0.36-1.824,2.132-3.01,3.955-2.649c1.824,0.361,3.011,2.132,2.649,3.955 c-0.43,2.173-1.072,4.289-1.914,6.322c-1.694,4.085-4.182,7.794-7.307,10.918C53.535,66.079,45.049,69.669,36,69.669 c-18.594,0-33.667-15.073-33.667-33.667C2.333,17.408,17.406,2.334,36,2.334L36,2.334z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.1453cd6c.svg";
export { ForwardRef as ReactComponent };